import { UserDetailsCard } from 'features/user';

export const UserDetailsPage = () => {
  return <UserDetailsCard />;
};
